import React from 'react';
import classNames from 'classnames/bind';
import { func } from 'prop-types';
import { CloseLinear } from "../../icons";
import styles from '../Select.css';
import { selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
export var ClearIndicator = function ClearIndicator(_ref) {
  var clearValue = _ref.clearValue,
      classes = _ref.selectProps.classes;

  var handleClear = function handleClear(e) {
    e.stopPropagation();
    setTimeout(function () {
      clearValue();
    }, 0);
  };

  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('ClearIcon', classes.clearIndicator),
    onMouseDown: handleClear,
    onTouchEnd: handleClear
  }, /*#__PURE__*/React.createElement(CloseLinear, null));
};
ClearIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  clearValue: func,
  selectProps: selectPropsPropTypes
} : {};